"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const sleep = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds));

var _default = sleep;
exports.default = _default;